// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"widthPicker_popupContainer__jE3Ge","largeWidthIcon":"widthPicker_largeWidthIcon___g5Sm","smallWidthIcon":"widthPicker_smallWidthIcon__uP2MY"};